import { Col } from 'react-bootstrap';
import { BsCalendar, BsAward } from 'react-icons/bs';
import { ContentCard, Label } from 'ypf-pas-general-ui-components';

import './MonthlyDescriptionServiceRequest.scss';
import {
  DetailRequestMonthly,
  DetailRequestMonthlyDefaultProp
} from '../../../../utils/globalPropTypes';
// import { ubicationTypeEnum } from '../../../../utils/dataStatus';

const MonthlyDescriptionServiceRequest = ({ details }) => {
  const isOyM = details?.operacion?.length;

  const getStringUnidadesNegocioOrOperations = () => {
    let value = '';

    if (details && !isOyM) {
      const unidadesNegocioNombre = details.unidadNegocio?.map(
        (unidadNegocio) => unidadNegocio.nombre
      );

      value = unidadesNegocioNombre.join(', ');
    }
    if (details && isOyM) {
      const operacionNombre = details.operacion?.map((operacion) => operacion.nombre);

      value = operacionNombre.join(', ');
    }

    return value;
  };

  return (
    <div className="card-monthly-description-service-request">
      <ContentCard className="d-flex" mark="close" orientation="vertical">
        <Col className="col-border space-left" sm={7}>
          <section className="pt-4">
            <div className="subtitle-top pt-2"> Servicio</div>
            <h2 className="title-description">{details?.servicio?.nombre}</h2>
          </section>
          <section>
            <div className="subtitle-top">Descripción</div>
            <p className="description-text">{details?.servicioDescripcion}</p>
          </section>
          <section className="pb-2">
            <div className="subtitle-top">Tipo de asignación</div>
            <p className="text-bold">{details?.tipoAsignacion?.nombre}</p>
          </section>
        </Col>
        <Col className="pt-1" sm={5}>
          <div className="col-border-rigth d-flex pt-4">
            <Label
              fullWidth={false}
              icon={BsCalendar}
              iconPosition="left"
              label="Fecha de realización"
              size="md"
              sizeValue="lg"
              value={details?.mes}
              variant="light"
            />
          </div>

          <div className="d-flex">
            <Label
              fullWidth={false}
              icon={BsAward}
              iconPosition="left"
              label="Proveedor y contrato"
              size="md"
              sizeValue="lg"
              value={details ? `${details?.proveedor} (${details?.numeroContrato})` : ''}
              variant="light"
            />
          </div>

          <div className="d-flex">
            <Label
              fullWidth={false}
              iconPosition="left"
              label="UUNN"
              size="md"
              sizeValue="lg"
              value={getStringUnidadesNegocioOrOperations()}
              variant="light"
            />
          </div>
        </Col>
      </ContentCard>
    </div>
  );
};

export default MonthlyDescriptionServiceRequest;

MonthlyDescriptionServiceRequest.propTypes = {
  details: DetailRequestMonthly
};

MonthlyDescriptionServiceRequest.defaultProps = {
  details: DetailRequestMonthlyDefaultProp
};
